import type { CleanupStatus } from '../../services/admin';
import { RETENTION_CATEGORIES, formatRetention } from './cleanupRetention';

/** Read-only view of the effective cleanup configuration (Settings > Cleanup & Retention). */
export default function EffectiveRetentionList({ status }: { status: CleanupStatus }) {
  return (
    <div className="text-sm space-y-1">
      {RETENTION_CATEGORIES.map((c) => (
        <div key={c.key}>
          <div className="flex justify-between">
            <span className="text-gray-400">{c.label}</span>
            <span>{formatRetention(c, status.retention[c.key])}</span>
          </div>
          {c.description && <p className="text-xs text-gray-500">{c.description}</p>}
        </div>
      ))}
      <div className="flex justify-between"><span className="text-gray-400">Scheduled interval</span><span>every {status.interval_hours}h</span></div>
      <div className="flex justify-between"><span className="text-gray-400">Batch size</span><span>{status.retention.batch_size}</span></div>
      <div className="flex justify-between"><span className="text-gray-400">Enabled</span><span>{status.enabled ? 'Yes' : 'No'}</span></div>
      <div className="flex justify-between"><span className="text-gray-400">Dry run</span><span>{status.dry_run ? 'Yes' : 'No'}</span></div>
    </div>
  );
}
